import locale from '../../../utils/locale';
import {capitalize} from '../../../utils/textTransform';

export default [
    {
        name: 'addressLine1',
        label: locale('addressLine1'),
        type: 'autoFillAddress',
        readable: true,
        editable: true,
        required: true
    },
    {
        name: 'addressLine2',
        label: locale('addressLine2'),
        type: 'text',
        readable: true,
        editable: true,
        required: true
    },
    {
        name: 'city',
        label: locale('city'),
        type: 'text',
        readable: true,
        editable: true,
        required: true
    },
    {
        name: 'state',
        label: locale('state'),
        type: 'text',
        readable: true,
        editable: true,
        required: true,
        maxLength: 2
    },
    {
        name: 'zip',
        label: locale('zip'),
        type: 'text',
        readable: true,
        editable: true,
        required: true,
        regEx: /(^(([A-Z][0-9]{1,2})|(([A-Z][A-HJ-Y][0-9]{1,2})|(([A-Z][0-9][A-Z])|([A-Z][A-HJ-Y][0-9]?[A-Z])))) [0-9][A-Z]{2}$)/,
        transform: capitalize

    }
]


// WEBPACK FOOTER //
// ./src/containers/PickupForm/fieldStructure/pickupAddress.uk.js